export default __webpack_public_path__ + "static/media/Chestguard of the Invincible.9510f587.jpg";